import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dropdownObject',
})
export class DropdownObjectPipe implements PipeTransform {
  transform(value: any, propertyName: string) {
    if (!value) {
      return;
    }
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        return Object.values(value).map(data => ` ${data[propertyName]}`);
      } else {
        return value[propertyName];
      }
    }
  }
}
